// import './about-widget/index';
import './newsletter/index';
import './contact-info/index';